import { LandscapeStreamline as LandscapeStreamlineIcon } from '@praetorian-chariot/ui';
import React from 'react';

interface OrganizationHeaderProps {
  displayName: string;
  profilePicture?: ArrayBuffer;
  subtitle?: string;
  className?: string;
}

export const OrganizationHeader: React.FC<OrganizationHeaderProps> = ({
  displayName,
  profilePicture,
  subtitle,
  className = '',
}) => (
  <div className={`border-chariot-stroke border-b pb-6 ${className}`}>
    <div className="flex items-center gap-6">
      {profilePicture ? (
        <div className="bg-chariot-background-secondary size-16 shrink-0 overflow-hidden rounded-lg">
          <img
            src={URL.createObjectURL(new Blob([profilePicture]))}
            alt={`${displayName} Logo`}
            className="size-full object-cover"
          />
        </div>
      ) : (
        <div className="bg-chariot-background-secondary flex size-16 shrink-0 items-center justify-center rounded-lg">
          <LandscapeStreamlineIcon className="text-chariot-stroke size-8" />
        </div>
      )}
      <div>
        <h2 className="text-chariot-text-primary text-lg font-semibold">
          {displayName}
        </h2>
        {subtitle && (
          <p className="text-chariot-text-secondary text-sm">{subtitle}</p>
        )}
      </div>
    </div>
  </div>
);
